module.exports = __webpack_public_path__ + "img/TUV_SUD_certificate.bbcfdb86.png";